import { FolderOpen } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../ui/tooltip";

// refs: [{kind, server_relative_path, web_url, item_name}] (seed histórico, solo lectura)
// innohubPath: string (campo editable nuevo, prevalece sobre refs si está puesto)
// OS no guarda el PDF — solo el enlace a InnoHub (emergent-enlaces-innohub.md)
export function InnoHubRefIcon({ refs, innohubPath, className = "" }) {
  // Fix 2026-10-25 (ticket P-6): la vista de lista usaba el ref sembrado
  // (histórico, nunca se actualiza) mientras la ficha ya mostraba el campo
  // editable `innohub_path` — podían discrepar (ej. CICLICOM). Ahora ambos
  // sitios usan la misma fuente: innohub_path si existe, si no el ref viejo.
  const url = innohubPath || refs?.[0]?.web_url;
  if (!url) return null;
  const pathLabel = innohubPath || refs?.[0]?.server_relative_path || url;
  return (
    <TooltipProvider>
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            data-testid="innohub-ref-icon"
            className={`inline-flex items-center text-slate-500 dark:text-slate-400 hover:text-emerald-600 transition-colors ${className}`}
          >
            <FolderOpen className="w-4 h-4" />
          </a>
        </TooltipTrigger>
        <TooltipContent data-testid="innohub-ref-icon-tooltip">
          <p className="font-medium">Abrir en InnoHub</p>
          <p className="text-[10px] opacity-80 font-mono max-w-[280px] truncate">{pathLabel}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function InnoHubRefBlock({ refs }) {
  if (!refs || refs.length === 0) return null;
  return (
    <div className="rounded-lg border border-dashed border-slate-300 dark:border-slate-700 p-3 space-y-2" data-testid="innohub-ref-block">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Expediente InnoHub</p>
      {refs.map((ref, i) => (
        <div key={i} className="flex items-center justify-between gap-3 text-xs">
          <span className="font-mono text-slate-500 truncate" title={ref.server_relative_path}>
            {ref.server_relative_path}
          </span>
          <a
            href={ref.web_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`innohub-ref-open-${i}`}
            className="flex-shrink-0 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-emerald-50 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-950/40 dark:text-emerald-400 font-medium"
          >
            <FolderOpen className="w-3 h-3" />Abrir en InnoHub
          </a>
        </div>
      ))}
      <p className="text-[10px] text-muted-foreground">El fichero no se guarda en el OS — este enlace abre InnoHub directamente.</p>
    </div>
  );
}
